var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGymn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFF",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    transform: "matrix(.69 0 0 .69 15.5 15.5)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.359 68.518l25.123 25.123a4.652 4.652 0 0 0 6.531.04L6.319 61.987a4.652 4.652 0 0 0 .04 6.531zM30.889 61.36l30.47-30.47 7.75 7.751-30.47 30.47zM8.317 51.137l-.246.246a6.01 6.01 0 0 0 0 8.491l.809.809h-.007l30.443 30.443v-.006l.809.809a6.01 6.01 0 0 0 8.491-.001l.246-.246a6.012 6.012 0 0 0 .001-8.491L16.809 51.137a6.012 6.012 0 0 0-8.492 0zM51.383 8.071l-.246.246a6.01 6.01 0 0 0 0 8.491l32.055 32.055a6.01 6.01 0 0 0 8.491-.001l.246-.246a6.012 6.012 0 0 0 .001-8.491L59.875 8.071a6.012 6.012 0 0 0-8.492 0zM61.979 6.327l31.699 31.689a4.651 4.651 0 0 0-.037-6.534L68.518 6.359a4.652 4.652 0 0 0-6.539-.032z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.2 86.8c1.661 1.661 4.035 2.338 6.351 1.812l1.926-.439-9.65-9.65-.439 1.926c-.527 2.316.151 4.69 1.812 6.351zM80.449 11.388l-1.926.439 9.65 9.65.439-1.926c.527-2.316-.151-4.69-1.812-6.351s-4.035-2.339-6.351-1.812z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGymn);
export default __webpack_public_path__ + "static/media/GYMN.573b4beff2eccee9d7ce821eb5c359f0.svg";
export { ForwardRef as ReactComponent };